import NavForMobile from "./nav-for-mobile.component";

export default NavForMobile;
